import { Pipe, PipeTransform } from '@angular/core';
import NP from 'number-precision'
import { notNullUndefined } from 'src/app/helpers/utils';

@Pipe({
  name: 'convertMeterToMile'
})
export class ConvertMeterToMilePipe implements PipeTransform {

  transform(value: number, ...args: unknown[]): string {
    return notNullUndefined(value)? NP.divide(value,1609.344).toFixed(2):'N/A'
  }

}
